var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var DekodeWoo = function () {
	this.$totalQty = $( document.getElementById( 'cart-total-qty' ) );
	this.$miniCartQty = $( document.querySelectorAll( '#container .cart_list .quantity-button' ) );
	this.$removeItem = $( document.querySelectorAll( '.mini-cart-remove' ) );
	this.timer = false;
	this.loading;
};

DekodeWoo.prototype.init = function () {

	var self = this,
		totalVal = parseInt( self.$totalQty.text() ),
		$quantity, quantKey, quantVal;

	self.$miniCartQty.click( function ( e ) {

		e.preventDefault();
		self.total_loading();

		$quantity = $( this ).siblings( 'span' ).children( '.quantity-value' );
		quantKey = $( this ).data( 'key' );
		quantVal = parseInt( $quantity.text() );

		if ( $( this ).hasClass( 'inc' ) ) {
			quantVal ++;
			totalVal ++;
		} else if ( quantVal > 1 ) {
			quantVal --;
			totalVal --;
		} else {
			quantVal = 1;
			totalVal = 1;
		}

		$quantity.text( quantVal );
		self.$totalQty.text( totalVal );
		self.mini_cart_update_quantity( quantKey, quantVal );
	} );

	self.$removeItem.click( function ( e ) {

		e.preventDefault();
		self.total_loading();

		var cart_items = $( this ).parents( 'li.mini_cart_item' ).siblings( 'li' );

		$( this ).parents( 'li.mini_cart_item' ).remove();

		if ( cart_items.length === 0 ) {

			$( document.getElementsByClassName( 'cart_list' ) )
				.addClass( 'empty' )
				.html( '<li class="empty">Ingen produkter i handlekurven</li>' );

			$( '.mini-cart-not-empty' ).remove();

		}

		self.mini_cart_remove_item( $( this ).data( 'key' ), $( this ).parents( '.mini_cart_item_inner' ).find( '.quantity-value' ).text() );

	} );

	if ( $( 'body' ).hasClass( 'wishlist' ) && $( window ).width() > 1000 ) {
		// Make sure the list description is at least as tall as the list
		var notices_height = $( document.getElementsByClassName( 'notices' ) ).outerHeight();
		var wl_intro = $( document.getElementsByClassName( 'wl-intro' ) );
		var wl_intro_height = wl_intro.outerHeight();
		if ( notices_height > 0 && notices_height > wl_intro_height ) {
			wl_intro.height( notices_height );
		}

	}
};

DekodeWoo.prototype.mini_cart_update_quantity = function ( key, qty ) {

	var self = this,
		data = {
			action: 'big_update_qty',
			ajax_nonce: big_ajax.ajax_nonce,
			item_key: key,
			item_qty: qty
		};

	$.post( big_ajax.url, data, function ( response ) {
		if ( response.success ) {
			self.mini_cart_update_totals();
			return;
		} else {
			console.log( response );
		}
	} ).fail( function ( xhr, textStatus, e ) {
		console.log( xhr.responseText );
	} );
};

DekodeWoo.prototype.mini_cart_update_totals = function () {

	var self = this,
		data = {
			action: 'big_update_totals',
			ajax_nonce: big_ajax.ajax_nonce
		};

	$.post( big_ajax.url, data, function ( response ) {
		if ( response.success ) {
			clearInterval( self.loading );
			var html = $( response.data );
			$( document.querySelectorAll( '.mini-cart-not-empty .total .amount' ) ).html( html );
			return;
		} else {
			console.log( response );
		}
	} ).fail( function ( xhr, textStatus, e ) {
		console.log( xhr.responseText );
	} );

};

DekodeWoo.prototype.mini_cart_remove_item = function ( key, quant ) {

	var self = this,
		data = {
			action: 'big_remove_product',
			ajax_nonce: big_ajax.ajax_nonce,
			item_key: key
		};

	var prevTotal = self.$totalQty.html();
	self.$totalQty.html( parseInt( prevTotal ) - quant );

	$.post( big_ajax.url, data, function ( response ) {
		if ( response.success ) {
			self.mini_cart_update_totals();
			return;
		} else {
			console.log( response );
		}
	} ).fail( function ( xhr, textStatus, e ) {
		console.log( xhr.responseText );
	} );
};

DekodeWoo.prototype.total_loading = function () {

	var self = this,
		count = 1;

	self.loading = setInterval( function () {
		if ( count > 3 ) {
			count = 1;
		}

		count ++;
		document.querySelectorAll( '.mini-cart-not-empty .total .amount' ).innerHTML = new Array( count % 10 ).join( '.' );
	}, 500 );
};

module.exports = new DekodeWoo;
